import type { RouteObject } from "react-router-dom";
import { OverviewPage } from "./OverviewPage";

export function overviewRoutes(): RouteObject[] {
  return [
    {
      index: true,
      element: <OverviewPage />,
      handle: { crumb: () => ({ label: "Übersicht" }) },
    },
  ];
}
